import { Divider } from 'antd';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/base/button';
import { H5 } from '../../../components/ui/base/typography';
import useSession from '../../../hooks/useSession';
import CreateNewDeclarationCard from '../../jobs/old-components/CreateNewDeclarationCard';
import AddTeamMember from './AddTeamMember';
import DashboardSearchBar from './DashboardSearchBar';
import Container from 'components/ui/base/container';
import JobsTable from '../../jobs/old-components/tables/JobsTable';

const Dashboard: FC = () => {
    const navigate = useNavigate();
    const { isAdminUser } = useSession();
    const { t } = useTranslation('dashboard');
    const { setBreadcrumbRoutes } = useBreadcrumb();

    const [createUserDrawerOpen, setCreateUserDrawerOpen] = useState<boolean>(false);
    const [createDeclarationModalVisible, setCreateDeclarationModalVisible] = useState<boolean>(false);

    useEffect(() => {
        setBreadcrumbRoutes([
            {
                breadcrumbName: 'Home',
                path: '',
            },
            {
                breadcrumbName: 'Dashboard',
                path: '',
            },
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createNewJob = () => {
        navigate('/jobs/new');
    };

    return (
        <Container>
            <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                <H5>{t('dashboardTitle')}</H5>
                <H5>{t('subTitle')}</H5>
            </div>
            <div style={{ display: 'flex', gap: '15px' }}>
                {isAdminUser && (
                    <Button
                        style={{ width: 200 }}
                        size="large"
                        type="primary"
                        onClick={() => setCreateUserDrawerOpen(true)}
                    >
                        {t('btAddTeamClerk')}
                    </Button>
                )}

                <Button style={{ width: 200 }} size="large" type="primary" onClick={createNewJob}>
                    {t('btCreateNewJob')}
                </Button>
                <Button
                    style={{ width: 200 }}
                    size="large"
                    type="primary"
                    onClick={() => setCreateDeclarationModalVisible(true)}
                >
                    {t('btCreateDeclarations')}
                </Button>
            </div>

            <Divider />

            <DashboardSearchBar />

            <CreateNewDeclarationCard
                isActive={createDeclarationModalVisible}
                handleCancel={() => setCreateDeclarationModalVisible(false)}
            />
            <AddTeamMember visible={createUserDrawerOpen} closeDrawer={() => setCreateUserDrawerOpen(false)} />

            <JobsTable />
        </Container>
    );
};
export default Dashboard;
